import PropTypes from 'prop-types';
import React from 'react';
import ViewContainer from '@loggi/ui/components/view-container';
import Display from '@loggi/ui/components/display';
import View from '@loggi/ui/components/view';
import Col from '@loggi/ui/components/col';
import Text from '@loggi/ui/components/text';
import Button from '@loggi/ui/components/button';
import styles from './index.scss';

const TEXT_EMPTY = '--';

/*
 * TODO: check impact and remove bottomGutter since
 * it needs to be applied by application side
 */

class DisplayInfo extends React.Component {
  static displayName = 'DisplayInfo';

  static propTypes = {
    label: PropTypes.string,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    format: PropTypes.string,
    onClickButton: PropTypes.func,
    component: PropTypes.any,
    bottomGutter: PropTypes.string
  };

  static defaultProps = {
    label: null,
    text: TEXT_EMPTY,
    format: null,
    bottomGutter: 'onehalf'
  };

  render() {
    const {
      label,
      text,
      component,
      onClickButton,
      format,
      bottomGutter
    } = this.props;

    const textFormated = label && !text ? TEXT_EMPTY : text;

    return (
      <ViewContainer fluid>
        {label && (
          <Col size={12} gutter={{ bottom: 'quarter' }}>
            <Text bold small color="medium">
              {label}
            </Text>
          </Col>
        )}
        <Col size={12} gutter={{ bottom: bottomGutter }}>
          <View inline className={styles.colButtonEdit}>
            {component ? (
              <View inline>{component}</View>
            ) : (
              <View inline className={styles.text}>
                <Text align="left" color="darkest" format={format}>
                  {textFormated}
                </Text>
              </View>
            )}
            <Display when={!!onClickButton}>
              {() => (
                <Button
                  onClick={onClickButton}
                  shape="circle"
                  style="outline"
                  color="active"
                  size="small"
                  icon="edit"
                />
              )}
            </Display>
          </View>
        </Col>
      </ViewContainer>
    );
  }
}

export default DisplayInfo;
